import { render, staticRenderFns } from "./NSWStampDutyExemptionForm.vue?vue&type=template&id=4ad65a72"
import script from "./NSWStampDutyExemptionForm.vue?vue&type=script&lang=js"
export * from "./NSWStampDutyExemptionForm.vue?vue&type=script&lang=js"
import style0 from "./NSWStampDutyExemptionForm.vue?vue&type=style&index=0&id=4ad65a72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports